import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import { TABLE_BORDER_COLOR } from 'HubStyleTokens/theme';
import { MERCURY_LAYER } from 'HubStyleTokens/sizes';
import UITable from 'UIComponents/table/UITable';
import { TABLE_TOP_BAR_HEIGHT, TABLE_PAGINATOR_HEIGHT } from '../constants/sizes';
import UIScrollOverhang from 'UIComponents/scroll/UIScrollOverhang';
import { forwardRef } from 'react';
const ScrollWindow = styled.div.withConfig({
  displayName: "StyledTableComponents__ScrollWindow",
  componentId: "ua4hz1-0"
})(["overflow:auto;max-width:100%;max-height:100%;"]);
const FullScrollOverhang = styled(UIScrollOverhang).withConfig({
  displayName: "StyledTableComponents__FullScrollOverhang",
  componentId: "ua4hz1-1"
})(["width:100%;height:100%;"]);
export const TableScrollContainer = /*#__PURE__*/forwardRef(({
  children
}, ref) => /*#__PURE__*/_jsx(FullScrollOverhang, {
  children: /*#__PURE__*/_jsx(ScrollWindow, {
    ref: ref,
    children: children
  })
}));
export const TableBox = styled((_ref) => {
  let rest = _objectWithoutPropertiesLoose(_ref, ["showPagination", "showTopBar"]);

  return /*#__PURE__*/_jsx(UIBox, Object.assign({}, rest));
}).withConfig({
  displayName: "StyledTableComponents__TableBox",
  componentId: "ua4hz1-2"
})(["width:100%;max-height:calc( 100% ", " ", " );border:1px solid ", ";"], ({
  showTopBar
}) => showTopBar ? `- ${TABLE_TOP_BAR_HEIGHT}` : '', ({
  showPagination
}) => showPagination ? `- ${TABLE_PAGINATOR_HEIGHT}` : '', TABLE_BORDER_COLOR);
export const FullFlex = styled(UIFlex).withConfig({
  displayName: "StyledTableComponents__FullFlex",
  componentId: "ua4hz1-3"
})(["width:100%;height:100%;overflow:hidden;"]);
export const StyledTable = styled(UITable).withConfig({
  displayName: "StyledTableComponents__StyledTable",
  componentId: "ua4hz1-4"
})(["border-width:0;table-layout:fixed;thead{position:sticky;top:0;background-color:white;z-index:", ";th{border-top-width:0;}}tbody{td{height:2.5rem;padding-bottom:0.15rem;padding-top:0.15rem;border:1px solid ", ";}tr{td:last-of-type{border-right-width:0;}td:first-of-type{border-left-width:0;}}tr:first-of-type{td{border-top-width:0;}}tr:last-of-type{td{border-bottom-width:0;}}}"], MERCURY_LAYER, TABLE_BORDER_COLOR);